import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TextPlugin } from 'gsap/TextPlugin';
gsap.registerPlugin( ScrollTrigger, TextPlugin );

export class Typewriter {
	constructor( selector, options = {} ) {
		// General
		this.elements = gsap.utils.toArray( selector );
		this.options = options;
		this.isEnable = false;
	}

	init() {
		if ( this.isEnable ) return;
		if ( ! this.elements?.length ) return;
		this.isEnable = true;
		const { words } = this.options;
		this.elements.forEach( ( ele ) => {
			const textBox = gsap.utils.toArray( '.el-text', ele );
			const symbolBox = gsap.utils.toArray( '.el-symbol', ele );
			const wordTl = gsap.timeline( { repeat: -1, paused: true } );
			const symbolTl = gsap.timeline( { repeat: -1, paused: true } );
			symbolTl
				.set( symbolBox, { opacity: 1 } )
				.set( symbolBox, { opacity: 0 }, '+=0.5' )
				.set( symbolBox, { opacity: 1 }, '+=0.5' );
			words.forEach( ( word ) => {
				const duration = this.options.duration || 1;
				const spaceDelay = this.options.spaceDelay
					? `+=${ this.options.spaceDelay }`
					: '+=0.2';
				const repeatDelay = this.options.contentDelay || 2;
				const toVars = { duration, text: word };
				const tlWord = gsap.timeline( {
					repeat: 1,
					yoyo: true,
					repeatDelay,
				} );
				tlWord.to( textBox, toVars, spaceDelay );
				wordTl.add( tlWord );
			} );
			ScrollTrigger.create( {
				trigger: ele,
				start: 'top bottom',
				end: 'bottom top',
				onToggle: ( self ) => {
					if ( self.isActive ) {
						wordTl.play();
						symbolTl.play();
					} else {
						wordTl.pause();
						symbolTl.pause();
					}
				},
			} );
		} );
	}
	kill() {}
	resize() {}
	destroy() {}
}
